// extracted by mini-css-extract-plugin
module.exports = {"brandBar":"index_brandBar_3N-Xv"};